import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'

export function useGuestsCount() {
  const store = useStore()
  const { t } = useI18n()

  const guestsCountString = (adultNb, childrenNb, infantsNb, isGenitive = false) => {
    const { adults, children, infants } = store.getters.guestsBounds
    const isAdultsOnlyHotel = store.getters.isAdultsOnlyHotel

    const adultsTotal = adultNb || adults.min
    const childrenTotal = childrenNb || children.min
    const infantsTotal = infantsNb || infants.min

    if (isAdultsOnlyHotel) {
      return !isGenitive
        ? t('Generic#GuestCount person', adultsTotal)
        : t('Generic#GuestCount#Genitive person', adultsTotal)
    }

    const adultStr = !isGenitive
      ? t('Generic#GuestCount adult', adultsTotal)
      : t('Generic#GuestCount#Genitive adult', adultsTotal)

    const andStr = t('Generic#GuestCount and')
    let allGuestsStr = adultStr

    if (childrenTotal > 0) {
      const childStr = !isGenitive
        ? t('Generic#GuestCount child', childrenTotal)
        : t('Generic#GuestCount#Genitive child', childrenTotal)
      allGuestsStr +=
        infantsTotal > 0 ? `, ${childStr}` : ` ${andStr} ${childStr}`
    }
    if (infantsTotal > 0) {
      const infantStr = !isGenitive
        ? t('Generic#GuestCount infant', infantsTotal)
        : t('Generic#GuestCount#Genitive infant', infantsTotal)
      allGuestsStr += ` ${andStr} ${infantStr}`
    }

    return allGuestsStr
  }

  return {
    guestsCountString
  }
}
